import React from 'react';
import 'react-day-picker/style.css';
import ReactDOM from 'react-dom/client';
import './amplify-config'; // <- important
import App from './App';
import './index.css';
import './styles/scrollbar.css';

import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
